import React from 'react'
import { Copy } from '../Copy'
import { WemoloTypography } from '../Wemolo'
import styles from './Info.module.css'

export const Info = ({
    label,
    value,
    copyValue,
    copyValueString
}: {
    label: React.ReactNode
    value?: React.ReactNode
    copyValue?: boolean
    copyValueString?: string | null
}) => {
    return (
        <div className={styles.root}>
            <div>
                <WemoloTypography variant="body-medium-emphasized" tag="span">
                    {label}
                </WemoloTypography>
            </div>
            <div>
                <WemoloTypography variant="body-small" tag="span">
                    {copyValue ? <Copy value={copyValueString} item={value} /> : value}
                </WemoloTypography>
            </div>
        </div>
    )
}
